var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "map-overlay" }, [
    _c(
      "div",
      { staticClass: "custom-toolbar" },
      [
        _c(
          "router-link",
          {
            attrs: {
              to: {
                name: "Team Settings",
              },
            },
          },
          [_c("h3", { staticClass: "title" }, [_vm._v("Team Settings")])]
        ),
        _c("h3", { staticClass: "title" }, [
          _vm._v("   >    " + _vm._s(_vm.$t("menus.setting.serviceAreas"))),
        ]),
      ],
      1
    ),
    _c("div", { staticClass: "service-area-main" }, [
      _c(
        "div",
        { staticClass: "service-area-panel" },
        [
          _c("ServiceAreaLayer", {
            attrs: {
              map: _vm.map,
              "drawing-manager": _vm.drawingManager,
              title: "Service area",
              "id-name": "serviceAreaId",
              "end-point-name": "/api/teams/service-areas",
              "list-end-point-name":
                "/api/teams/service-areas?excludeBoundaryDetails=true",
              "details-end-point-name": "/api/teams/service-areas",
            },
          }),
        ],
        1
      ),
      _c("div", {
        ref: "googleMap",
        class: [_vm.isTrialExpired ? "not-paid-map-overlay" : "", "google-map"],
        attrs: { id: "map_canvas" },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }